import React from "react";
import { Card, CardBody, CardHeader, Table, Button, Dropdown } from "react-bootstrap";

const DailyScheduleTab = ({
  currentDate,
  getAllDates,
  handleDateNavigation,
  getResidentsForDate,
  rotationColors,
  getRotationLabel,
  pagerNumbers,
  residentPagerNumbers,
  formatPhoneNumber,
  capitalizeName,
}) => {
  const allDates = getAllDates();

  if (allDates.length === 0) {
    return (
      <Card className="mb-4 shadow-sm border-0 py-4">
        <CardBody className="p-0">
          <div className="text-center py-4">
            <div className="d-flex flex-column align-items-center gap-2">
              <img src="/images/undraw_schedule_6t8k.svg" alt="No schedule" className="img-fluid" style={{height: "200px"}} />
              <h5>No Day to Day schedules available</h5>
              <p className="text-muted">Please create a rotation schedule first</p>
            </div>
          </div>
        </CardBody>
      </Card>
    );
  }

  const currentDateStr = currentDate.toISOString().split("T")[0];
  const residentsByRotation = getResidentsForDate(currentDate);
  const currentIndex = allDates.length > 0 ? allDates.indexOf(currentDateStr) : -1;

  return (
    <Card className="mb-4 shadow-sm border-0">
      <CardHeader className="px-4 py-3 d-flex border-0 flex-row justify-content-between align-items-start">
        <div className="d-flex flex-row align-items-center justify-content-start gap-3">
          <div className="d-flex flex-column">
          <h6 className="fw-semibold mb-0">Daily Schedule</h6>
          <p className="text-muted small mb-0"> {currentDate.toLocaleDateString(undefined, {
                weekday: "long",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}</p>
          </div>
          {(currentDate.getDay() === 0 || currentDate.getDay() === 6) && (
            <div className="d-flex flex-row align-items-center justify-content-start gap-2">
              <span className="badge bg-danger">
                <i className="bi bi-telephone-fill"></i>
              </span>
              <span className="text-muted small">Shown for weekend call assignments</span>
            </div>
          )}
        </div>
        <div className="d-flex align-items-center gap-2">
          <div className="radio-inputs d-flex align-items-center" style={{ width: "fit-content" }}>
            <label className="radio">
              <input
                type="radio"
                checked={false}
                readOnly
                onClick={() => handleDateNavigation("prev")}
                disabled={currentIndex <= 0 || allDates.length === 0}
              />
              <span
                className="name bg-white-hover px-2"
                onClick={() =>
                  !(currentIndex <= 0 || allDates.length === 0) &&
                  handleDateNavigation("prev")
                }
              >
                <i className="bi bi-chevron-left"></i>
              </span>
            </label>
            <span className="name px-2 text-nowrap">
              {currentDate.toLocaleDateString(undefined, {
                weekday: "long",
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </span>
            <label className="radio">
              <input
                type="radio"
                checked={false}
                readOnly
                onClick={() => handleDateNavigation("next")}
                disabled={currentIndex >= allDates.length - 1 || allDates.length === 0}
              />
              <span
                className="name bg-white-hover px-2"
                onClick={() =>
                  !(currentIndex >= allDates.length - 1 || allDates.length === 0) &&
                  handleDateNavigation("next")
                }
              >
                <i className="bi bi-chevron-right"></i>
              </span>
            </label>
          </div>
        </div>
      </CardHeader>
      <CardBody className="p-0">
        {Object.keys(residentsByRotation).length === 0 ? (
          <div className="text-center py-4">
            <h5>No rotations scheduled for this date</h5>
            <p className="text-muted">Please check the rotation schedule for this month</p>
          </div>
        ) : (
          <Table responsive className="alt-table-striped">
            <thead>
              <tr className="custom-header-bg">
                <th className="ps-4">Rotation</th>
                <th className="text-start">Residents</th>
                <th>Attendings</th>
                <th>APPs</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(residentsByRotation).map(([rotation, residents]) => (
                <tr key={rotation}>
                  <td className="ps-4">
                    <div className="d-flex align-items-center gap-2">
                      <span
                        className="d-inline-block text-nowrap"
                        style={{
                          backgroundColor: rotationColors[rotation] || '#6B7280',
                          color: 'white',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '0.875rem',
                          fontWeight: '600'
                        }}
                      >
                        {getRotationLabel(rotation)}
                      </span>
                      {pagerNumbers[rotation] && (
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="light"
                            size="sm"
                            className="py-1 px-2 no-arrow"
                            style={{ color: 'inherit' }}
                          >
                            <i className="bi bi-telephone" style={{ fontSize: '.8rem' }}></i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.ItemText>
                              <div className="d-flex align-items-center justify-content-between">
                                <span className="me-3 text-nowrap">{formatPhoneNumber(pagerNumbers[rotation])}</span>
                                <Button
                                  variant="link"
                                  size="sm"
                                  className="p-1"
                                  onClick={(event) => {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    navigator.clipboard.writeText(formatPhoneNumber(pagerNumbers[rotation]));
                                    const button = event.currentTarget;
                                    const icon = button.querySelector('i');
                                    if (icon) {
                                      icon.className = 'bi bi-check';
                                      button.className = 'btn link-success btn-sm p-1';
                                      setTimeout(() => {
                                        icon.className = 'bi bi-clipboard';
                                        button.className = 'btn link-primary btn-sm p-1';
                                      }, 1000);
                                    }
                                  }}
                                >
                                  <i className="bi bi-clipboard"></i>
                                </Button>
                              </div>
                            </Dropdown.ItemText>
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                    {(currentDate.getDay() === 0 || currentDate.getDay() === 6) && (
                      <div className="small text-muted mt-1">
                        {residents.filter(r => r.isOnCall).length} on call
                      </div>
                    )}
                  </td>
                  <td>
                    {residents.length === 0 ? (
                      <div className="text-muted">No residents assigned</div>
                    ) : (
                      residents.map((resident, index) => (
                        <div key={`${resident.id}-${index}`}>
                          <span className="d-flex align-items-center gap-2">
                            {capitalizeName(resident.name)} (PGY-{resident.year})
                            {residentPagerNumbers[resident.id] && (
                              <Dropdown>
                                <Dropdown.Toggle
                                  variant="light"
                                  size="sm"
                                  className="py-1 px-2 no-arrow"
                                  style={{ color: 'inherit' }}
                                >
                                  <i className="bi bi-telephone" style={{ fontSize: '0.8rem' }}></i>
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  <Dropdown.ItemText>
                                    <div className="d-flex align-items-center justify-content-between">
                                      <span className="me-3 text-nowrap fw-semibold">{formatPhoneNumber(residentPagerNumbers[resident.id])}</span>
                                      <Button
                                        variant="light-lite"
                                        size="sm"
                                        className="py-1 px-2"
                                        onClick={(event) => {
                                          event.preventDefault();
                                          event.stopPropagation();
                                          navigator.clipboard.writeText(formatPhoneNumber(residentPagerNumbers[resident.id]));
                                          const button = event.currentTarget;
                                          const icon = button.querySelector('i');
                                          if (icon) {
                                            icon.className = 'bi bi-check';
                                            button.className = 'btn link-success btn-sm p-1';
                                            setTimeout(() => {
                                              icon.className = 'bi bi-clipboard';
                                              button.className = 'btn link-primary btn-sm p-1';
                                            }, 1000);
                                          }
                                        }}
                                      >
                                        <i className="bi bi-clipboard"></i>
                                      </Button>
                                    </div>
                                  </Dropdown.ItemText>
                                </Dropdown.Menu>
                              </Dropdown>
                            )}
                            {resident.isOnCall && (
                              <span className="badge bg-danger" style={{ fontSize: '0.7rem', animation: 'pulse 2s infinite' }}>
                                <i className="bi bi-telephone-fill me-1"></i>
                                On Call
                              </span>
                            )}
                          </span>
                        </div>
                      ))
                    )}
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </CardBody>
    </Card>
  );
};

export default DailyScheduleTab;

